// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getWishListLinesDataView } from "@insite/client-framework/Store/Data/WishListLines/WishListLinesSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import InfosBox, { InfosBoxProps } from "@store/Library/Components/Toolkit/InfosBox";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";

const mapStateToProps = (state: ApplicationState) => ({
    wishListLinesDataView: getWishListLinesDataView(state, state.pages.myListDetails.loadWishListLinesParameter),
});

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

export interface MyListDetailsWarningMessageStyles {
    myListDetailsWarningMessageInfosBox?: InfosBoxProps;
}

export const myListDetailsWarningMessageStyles: MyListDetailsWarningMessageStyles = {
    myListDetailsWarningMessageInfosBox: { type: "warning" },
};

const MyListDetailsWarningMessage: React.FC<Props> = ({ wishListLinesDataView }) => {
    const [canAddAllToCart, setCanAddAllToCart] = useState(false);
    const [isWishListLoaded, setIsWishListLoaded] = useState(false);

    useEffect(() => {
        if (wishListLinesDataView.isLoading) {
            setIsWishListLoaded(false);
            return;
        }

        const newCanAddAllToCart = wishListLinesDataView.value?.every(line => line.canAddToCart) ?? false;
        setCanAddAllToCart(newCanAddAllToCart);
        setIsWishListLoaded(true);
    }, [wishListLinesDataView]);

    if (!isWishListLoaded || canAddAllToCart) {
        return null;
    }

    return (
        <InfosBox {...myListDetailsWarningMessageStyles.myListDetailsWarningMessageInfosBox}>
            {translate("My List Details Warning Message")}
        </InfosBox>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(MyListDetailsWarningMessage),
    definition: {
        group: "My Lists Details",
        displayName: "My Lists Details Warning Message",
        allowedContexts: ["MyListsDetailsPage"],
    },
};

export default widgetModule;
